import { useState, useRef, useEffect } from "react";
import {
  HiOutlineCog,
  HiOutlineRefresh,
  HiCheck,
  HiOutlineExclamation,
} from "react-icons/hi";
import Button from "../../../../../components/button/button";
import Notification from "../../../../../components/notification/notification";
import "../precio/precio.scss";

// Arrays V2 para mostrar labels
const acabadoPrincipalV2 = [
  { label: "Sin acabado / En bruto", value: 10 },
  { label: "Pintura al agua básica", value: 11 },
  { label: "Lacado mate monocapa", value: 12 },
  { label: "Lacado mate bicapa", value: 13 },
  { label: "Lacado semibrillo", value: 14 },
  { label: "Lacado alto brillo", value: 15 },
  { label: "Lacado texturizado", value: 16 },
  { label: "Pintura metálica / perlada", value: 17 },
  { label: "Melamina estándar", value: 20 },
  { label: "Melamina extra mate", value: 21 },
  { label: "Laminado HPL estándar", value: 22 },
  { label: "Laminado HPL macizo autoportante", value: 23 },
  { label: "Vinilo PVC impreso", value: 24 },
  { label: "Chapa madera roble", value: 30 },
  { label: "Chapa madera haya", value: 31 },
  { label: "Chapa madera nogal", value: 32 },
  { label: "Chapa madera wengué", value: 33 },
  { label: "Chapa madera teca", value: 34 },
  { label: "Tela estándar", value: 40 },
  { label: "Tela premium", value: 41 },
  { label: "Tela técnica antimanchas", value: 42 },
  { label: "Polipiel / Cuero sintético", value: 43 },
  { label: "Cuero natural", value: 44 },
  { label: "Cuero ecológico", value: 45 },
  { label: "Microcemento", value: 50 },
  { label: "Mármol natural", value: 51 },
  { label: "Granito natural", value: 52 },
  { label: "Silestone / Cuarzo compacto", value: 53 },
  { label: "Vidrio templado lacado", value: 54 },
  { label: "Vidrio serigrafiado", value: 55 },
  { label: "Terrazo", value: 56 },
  { label: "Corcho", value: 57 },
  { label: "Arcilla", value: 58 },
  { label: "Acero lacado alto brillo", value: 60 },
  { label: "Latón cepillado", value: 61 },
  { label: "Cobre natural con pátina", value: 62 },
  { label: "Aluminio anodizado", value: 63 },
  { label: "Hierro fundido", value: 64 },
];

const acabadoSecundarioV2 = [
  { label: "Sin acabado secundario", value: 10 },

  { label: "Lacado mate", value: 11 },
  { label: "Lacado alto brillo", value: 12 },

  { label: "Melamina estándar", value: 20 },
  { label: "Melamina extra mate", value: 21 },
  { label: "Laminado HPL estándar", value: 22 },
  { label: "Laminado HPL macizo autoportante", value: 23 },
  { label: "Vinilo PVC impreso", value: 24 },

  { label: "Chapa madera roble", value: 30 },
  { label: "Chapa madera haya", value: 31 },
  { label: "Chapa madera nogal", value: 32 },
  { label: "Chapa madera wengué", value: 33 },
  { label: "Chapa madera teca", value: 34 },

  { label: "Hierro lacado alto brillo", value: 40 },
  { label: "Hierro lacado mate/satinado", value: 41 },
  { label: "Latón cepillado", value: 42 },
  { label: "Cobre natural con pátina", value: 43 },
  { label: "Aluminio anodizado", value: 44 },
  { label: "Acero inoxidable", value: 45 }
];

const estructuraPrincipalV2 = [
  { label: "Tablero DM / MDF", value: 100 },
  { label: "Tablero contrachapado marino", value: 101 },
  { label: "Tablero OSB", value: 102 },
  { label: "Tablero aglomerado", value: 103 },
  { label: "Tablero fenólico", value: 104 },
  { label: "Tablero melamínico", value: 105 },
  { label: "Madera maciza pino", value: 110 },
  { label: "Madera maciza haya", value: 111 },
  { label: "Madera maciza roble", value: 112 },
  { label: "Madera maciza nogal", value: 113 },
  { label: "Madera maciza teca", value: 114 },
  { label: "Madera maciza cerezo", value: 115 },
  { label: "Hierro lacado", value: 120 },
  { label: "Acero inoxidable", value: 121 },
  { label: "Aluminio", value: 122 },
  { label: "Latón", value: 123 },
  { label: "Cobre", value: 124 },
  { label: "Policarbonato", value: 130 },
  { label: "Hormigón GRC", value: 131 },
  { label: "Hormigón UHPC", value: 132 },
  { label: "Resina epoxi", value: 133 },
  { label: "Vidrio templado", value: 134 },
  { label: "Cristal laminado", value: 135 },
];

const iluminacionV2 = [
  { label: "Sin iluminación", value: 0 },
  { label: "LED tira básica", value: 1 },
  { label: "LED tira regulable", value: 2 },
  { label: "LED tira regulable + mando", value: 3 },
  { label: "Retroiluminación pantalla/panel", value: 4 },
  { label: "Lightbox", value: 5 },
  { label: "LED RGB", value: 6 },
  { label: "LED RGBW premium", value: 7 },
  { label: "Neón flexible", value: 8 },
];

// Helper para obtener el label de un value
const getLabelByValue = (array, value) => {
  const item = array.find((i) => String(i.value) === String(value));
  return item ? item.label : `ID: ${value}`;
};

export default function ModifiersUpdater() {
  const [modifiers, setModifiers] = useState(null);
  const [originalModifiers, setOriginalModifiers] = useState(null);
  const [loading, setLoading] = useState(false);
  const [updating, setUpdating] = useState(false);
  const [updateSuccess, setUpdateSuccess] = useState(false);
  const [error, setError] = useState(null);

  const notificationRef = useRef();

  const getApiUrl = () => {
    if (typeof window !== "undefined" && window.config?.REACT_APP_API_URL) {
      return window.config.REACT_APP_API_URL;
    }
    return "http://localhost:5001";
  };

  // Cargar modificadores desde la API
  const loadModifiers = async () => {
    setLoading(true);
    setError(null);
    const apiUrl = getApiUrl();

    try {
      const response = await fetch(`${apiUrl}/api/precios/modifiers`, {
        method: "GET",
        headers: { "Content-Type": "application/json" }
      });

      if (!response.ok) {
        throw new Error("Error al cargar los modificadores");
      }

      const data = await response.json();
      const groups = data.modifiers?.groups || data.groups || data;

      const loadedModifiers = {
        acabado_principal: groups.acabado_principal || {},
        acabado_secundario: groups.acabado_secundario || {},
        estructura_principal: groups.estructura_principal || {},
        iluminacion: groups.iluminacion || {},
      };

      setModifiers(loadedModifiers);
      setOriginalModifiers(JSON.parse(JSON.stringify(loadedModifiers)));

      notificationRef.current?.addNotification(
        "Modificadores cargados correctamente",
        "success"
      );
    } catch (err) {
      setError(err.message || "Error desconocido");
      notificationRef.current?.addNotification(
        err.message || "Error al cargar los modificadores",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  // Actualizar un valor específico
  const handleValueChange = (groupName, key, newValue) => {
    setModifiers((prev) => ({
      ...prev,
      [groupName]: {
        ...prev[groupName],
        [key]: parseFloat(newValue) || 0,
      },
    }));
  };

  // Construir el array de ModifierItem para enviar
  const buildModifiersArray = () => {
    if (!modifiers || !originalModifiers) return [];

    const result = [];
    const groups = ["acabado_principal", "acabado_secundario", "estructura_principal", "iluminacion"];

    groups.forEach((groupName) => {
      const currentGroup = modifiers[groupName] || {};
      const originalGroup = originalModifiers[groupName] || {};

      Object.keys(currentGroup).forEach((key) => {
        const currentValue = currentGroup[key];
        const originalValue = originalGroup[key];

        // Solo enviar si el valor cambió
        if (currentValue !== originalValue) {
          result.push({
            Code: key,
            Value: currentValue,
            Type: groupName,
          });
        }
      });
    });

    return result;
  };

  // Enviar actualización al endpoint
  const handleUpdate = async () => {
    const modifiersArray = buildModifiersArray();

    if (modifiersArray.length === 0) {
      notificationRef.current?.addNotification(
        "No hay cambios para actualizar",
        "warning"
      );
      return;
    }

    setUpdating(true);
    setError(null);
    setUpdateSuccess(false);
    const apiUrl = getApiUrl();

    try {
      const response = await fetch(`${apiUrl}/api/precios/updateModifiers`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          Modifiers: modifiersArray,
        }),
      });

      if (!response.ok) {
        throw new Error("Error al actualizar los modificadores");
      }

      setUpdateSuccess(true);
      setOriginalModifiers(JSON.parse(JSON.stringify(modifiers)));

      notificationRef.current?.addNotification(
        `${modifiersArray.length} modificador(es) actualizado(s) correctamente`,
        "success"
      );

      setTimeout(() => {
        setUpdateSuccess(false);
      }, 3000);
    } catch (err) {
      setError(err.message || "Error al actualizar");
      notificationRef.current?.addNotification(
        err.message || "Error al actualizar los modificadores",
        "error"
      );
    } finally {
      setUpdating(false);
    }
  };

  // Verificar si hay cambios pendientes
  const hasChanges = () => {
    if (!modifiers || !originalModifiers) return false;

    const groups = ["acabado_principal", "acabado_secundario", "estructura_principal", "iluminacion"];

    return groups.some((groupName) => {
      const currentGroup = modifiers[groupName] || {};
      const originalGroup = originalModifiers[groupName] || {};

      return Object.keys(currentGroup).some(
        (key) => currentGroup[key] !== originalGroup[key]
      );
    });
  };

  // Contar cambios pendientes
  const countChanges = () => {
    return buildModifiersArray().length;
  };

  useEffect(() => {
    loadModifiers();
  }, []);

  const GROUP_CONFIG = {
    acabado_principal: { label: "Acabado Principal", array: acabadoPrincipalV2 },
    acabado_secundario: { label: "Acabado Secundario", array: acabadoSecundarioV2 },
    estructura_principal: { label: "Estructura Principal", array: estructuraPrincipalV2 },
    iluminacion: { label: "Iluminación", array: iluminacionV2 },
  };

  return (
    <div className="precio">
      <Notification ref={notificationRef} />

      {/* Header */}
      <div className="precio__header">
        <h2>Actualizar Modificadores V2</h2>
        <p>Edita los valores de los modificadores y guarda los cambios</p>

        <div className="precio__header__actions">
          <Button
            type="secondary"
            onClick={loadModifiers}
            disabled={loading}
            state={loading}
            label={<>
                        <HiOutlineRefresh
              style={{
                marginRight: "8px",
                animation: loading ? "spin 1s linear infinite" : "none",
              }}
            />
            Recargar Modificadores
            </>}
          >

          </Button>
        </div>
      </div>

      {/* Error */}
      {error && (
        <div
          style={{
            marginBottom: "24px",
            padding: "16px",
            backgroundColor: "rgba(239, 68, 68, 0.1)",
            border: "1px solid rgba(239, 68, 68, 0.2)",
            borderRadius: "12px",
            display: "flex",
            alignItems: "center",
            gap: "12px",
            color: "#dc2626",
          }}
        >
          <HiOutlineExclamation style={{ fontSize: "20px", flexShrink: 0 }} />
          <span>{error}</span>
        </div>
      )}

      {/* Main Content */}
      <div className="precio__form">
        <h3 className="precio__form__titulo">
          Modificadores
          {hasChanges() && (
            <span
              style={{
                marginLeft: "12px",
                fontSize: "14px",
                fontWeight: 400,
                color: "#f59e0b",
              }}
            >
              ({countChanges()} cambio{countChanges() !== 1 ? "s" : ""} pendiente{countChanges() !== 1 ? "s" : ""})
            </span>
          )}
        </h3>

        {loading ? (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "48px 0",
            }}
          >
            <HiOutlineRefresh
              style={{
                fontSize: "32px",
                animation: "spin 1s linear infinite",
                color: "#6b7280",
              }}
            />
            <span style={{ marginLeft: "12px", color: "#6b7280" }}>
              Cargando modificadores...
            </span>
          </div>
        ) : modifiers ? (
          <div>
            {Object.entries(GROUP_CONFIG).map(([groupName, config]) => (
              <ModifierGroupSection
                key={groupName}
                groupName={groupName}
                label={config.label}
                labelArray={config.array}
                values={modifiers[groupName] || {}}
                originalValues={originalModifiers?.[groupName] || {}}
                onValueChange={handleValueChange}
              />
            ))}
          </div>
        ) : (
          <div style={{ textAlign: "center", padding: "48px 0", color: "#6b7280" }}>
            No se han cargado modificadores
          </div>
        )}

        {/* Actions */}
        <div className="precio__form__actions">
          <Button
            type={updateSuccess ? "saved" : "primary"}
            onClick={handleUpdate}
            disabled={updating || !hasChanges() || updateSuccess}
            className={updateSuccess ? "button--saved" : ""}
            label=            {updating ? (
              <>
                <HiOutlineRefresh
                  style={{
                    marginRight: "8px",
                    animation: "spin 1s linear infinite",
                  }}
                />
                Actualizando...
              </>
            ) : updateSuccess ? (
              <>
                <HiCheck style={{ marginRight: "8px" }} />
                Guardado
              </>
            ) : (
              <>
                {/* <HiOutlineCog style={{ marginRight: "8px" }} /> */}
                Actualizar Modificadores
              </>
            )}
          >

          </Button>
        </div>
      </div>

      {/* Estilos adicionales */}
      <style jsx>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}

// Componente para cada grupo de modificadores
function ModifierGroupSection({
  groupName,
  label,
  labelArray,
  values,
  originalValues,
  onValueChange,
}) {
  const items = Object.entries(values);

  if (items.length === 0) {
    return (
      <div className="precio__form__section">
        <h3>{label}</h3>
        <p style={{ color: "#6b7280", fontSize: "14px" }}>
          No hay valores definidos
        </p>
      </div>
    );
  }

  return (
    <div className="precio__form__section">
      <h3>{label}</h3>
      <div className="precio__summary__content">
        {items.map(([key, value]) => {
          const originalValue = originalValues[key];
          const hasChanged = value !== originalValue;
          const itemLabel = getLabelByValue(labelArray, key);

          return (
            <div
              key={key}
              className="precio__summary__item"
              style={{
                borderColor: hasChanged ? "#f59e0b" : undefined,
                backgroundColor: hasChanged ? "rgba(245, 158, 11, 0.05)" : undefined,
                transition: "all 0.2s ease",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: "8px",
                }}
              >
                <strong style={{ fontSize: "13px" }}>{itemLabel}</strong>
                {hasChanged && (
                  <span
                    style={{
                      fontSize: "11px",
                      padding: "2px 8px",
                      borderRadius: "12px",
                      backgroundColor: "#fef3c7",
                      color: "#92400e",
                    }}
                  >
                    Modificado
                  </span>
                )}
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                }}
              >
                {hasChanged && (
                  <div style={{ flex: 1 }}>
                    <span
                      style={{
                        color: "#6b7280",
                        fontSize: "11px",
                        display: "block",
                        marginBottom: "2px",
                      }}
                    >
                      Original
                    </span>
                    <span
                      style={{
                        fontWeight: 400,
                        color: "#9ca3af",
                        textDecoration: "line-through",
                      }}
                    >
                      {originalValue?.toFixed(2)}
                    </span>
                  </div>
                )}

                <div style={{ flex: 1 }}>
                  <span
                    style={{
                      color: "#6b7280",
                      fontSize: "11px",
                      display: "block",
                      marginBottom: "2px",
                    }}
                  >
                    Valor
                  </span>
                  <input
                    type="number"
                    step="0.01"
                    value={value}
                    onChange={(e) => onValueChange(groupName, key, e.target.value)}
                    style={{
                      width: "100%",
                      padding: "6px 10px",
                      border: "1px solid #e5e7eb",
                      borderRadius: "6px",
                      fontSize: "14px",
                      fontWeight: 500,
                      outline: "none",
                      transition: "border-color 0.2s",
                    }}
                    onFocus={(e) => (e.target.style.borderColor = "#3b82f6")}
                    onBlur={(e) => (e.target.style.borderColor = "#e5e7eb")}
                  />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}